import React from "react";
import { FileInput } from "../inputs/FileInput.js";

export const GetFileContentButton = ({
  children,
  onComplete,
}: {
  children: React.ReactElement;
  onComplete: (content: string) => void;
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const button = React.cloneElement(children, {
    onClick: (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      inputRef.current?.click();
    },
  });

  return (
    <>
      {button}
      <FileInput
        innerRef={inputRef}
        accept="text/css"
        multiple={false}
        onComplete={async file => {
          const content = await file.text();
          onComplete(content);
        }}
      />
    </>
  );
};
